// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Call: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M5.07,23.76c-0.89,0-1.93-0.67-2.53-1.13C1.73,22.01,1,21.27,0.65,20.68c-1.38-2.27,1.51-7.8,6.87-13.16
	c4.42-4.42,9.01-7.28,11.68-7.28c0.61,0,1.12,0.15,1.51,0.44c1.04,0.77,3.52,3.48,2.89,5.01c-0.41,1.01-4.99,3.59-5.83,3.61l-0.13,0
	l-0.12-0.04c-0.28-0.1-0.74-0.36-1.47-0.77c-0.6-0.34-1.26-0.71-1.59-0.84c-0.58,0-2.25,1.25-3.91,2.91
	c-0.87,0.87-1.64,1.75-2.17,2.49c-0.79,1.08-0.74,1.42-0.73,1.42c0.12,0.33,0.5,0.99,0.83,1.58c0.42,0.75,0.67,1.2,0.77,1.48
	l0.04,0.12l0,0.12c0,0.81-2.65,5.49-3.67,5.9C5.44,23.73,5.26,23.76,5.07,23.76z M19.19,1.64c-2.25,0-6.65,2.83-10.69,6.87
	c-5.45,5.45-7.4,10.23-6.66,11.44c0.26,0.43,0.88,1.06,1.54,1.56C4.42,22.3,5,22.39,5.1,22.36c0.48-0.34,2.43-3.62,2.75-4.54
	c-0.13-0.26-0.39-0.72-0.58-1.07c-0.39-0.69-0.78-1.38-0.94-1.81c-0.26-0.68,0.02-1.5,0.91-2.73c0.57-0.79,1.4-1.74,2.32-2.66
	c1.24-1.24,3.52-3.32,4.88-3.32c0.18,0,0.35,0.03,0.51,0.09c0.43,0.16,1.12,0.55,1.78,0.93c0.37,0.21,0.84,0.47,1.1,0.6
	c0.83-0.28,4.12-2.22,4.5-2.77c0.09-0.43-1.27-2.42-2.46-3.3C19.73,1.69,19.49,1.64,19.19,1.64z"/>
</svg>;
};

export default React.memo(Call);
